import { SagaIterator } from "redux-saga";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";
import { exploreRedux } from "../redux/explore-redux/ExploreRedux";

export function* SearchProfilesInExploreSaga(api: any, action: any): SagaIterator {
  const response = yield call(api.searchProfilesInExplore, action.payload);
  try {
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(exploreRedux.actions.searchProfilesIInExploreSuccess(response?.data));
    } else {
      yield put(exploreRedux.actions.searchProfilesIInExploreFailure(response?.data));
    }
  } catch (error: any) {
    yield put(exploreRedux.actions.searchProfilesIInExploreFailure(error));
  }
}

export function* serachPostsInExplore(api: any, action: any): SagaIterator {
  const response = yield call(api.serachPostsInExplore, action.payload);
  try {
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(exploreRedux.actions.serachPostsInExploreSuccess(response?.data));
    } else {
      yield put(exploreRedux.actions.serachPostsInExploreFailure(response?.data));
    }
  } catch (error: any) {
    yield put(exploreRedux.actions.serachPostsInExploreFailure(error));
  }
}

export function* serachProjectsInExplore(api: any, action: any): SagaIterator {
  const response = yield call(api.serachProjectsInExplore, action.payload);
  // console.log(response, "explore saga")
  try {
    if (response.status === HttpResponseTypeEnum.Success) {
      // console.log("success");
      yield put(exploreRedux.actions.serachProjectsInExploreSuccess(response?.data));
    } else {
      // console.log("failure");
      yield put(exploreRedux.actions.serachProjectsInExploreFailure(response?.data));
    }
  } catch (error: any) {
    yield put(exploreRedux.actions.serachProjectsInExploreFailure(error));
  }
}

export function* serachAllProjectsInExplore(api: any, action: any): SagaIterator {
  const response = yield call(api.serachAllProjectsInExplore, action.payload);
  try {
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(exploreRedux.actions.serachAllProjectsInExploreSuccess(response?.data));
    } else {
      yield put(exploreRedux.actions.serachAllProjectsInExploreFailure(response?.data));
    }
  } catch (error: any) {
    yield put(exploreRedux.actions.serachAllProjectsInExploreFailure(error));
  }
}

export function* serachArtistsInExplore(api: any, action: any): SagaIterator {
  const response = yield call(api.serachArtistInExplore, action.payload);
  try {
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(exploreRedux.actions.serachArtistInExploreSuccess(response?.data));
    } else {
      yield put(exploreRedux.actions.serachArtistInExploreFailure(response?.data));
    }
  } catch (error: any) {
    yield put(exploreRedux.actions.serachArtistInExploreFailure(error));
  }
}

export function* projectFilterInExplore(api: any, action: any): SagaIterator {
  const response = yield call(api.projectFilterInExplore, action.payload);
  try {
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(exploreRedux.actions.projectFilterInExploreSuccess(response?.data));
    } else {
      yield put(exploreRedux.actions.projectFilterInExploreFailure(response?.data));
    }
  } catch (error: any) {
    yield put(exploreRedux.actions.projectFilterInExploreFailure(error));
  }
}

export function* postFilterInExplore(api: any, action: any): SagaIterator {
  const response = yield call(api.postFilterInExplore, action.payload);
  try {
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(exploreRedux.actions.postFilterInExploreSuccess(response?.data));
    } else {
      yield put(exploreRedux.actions.postFilterInExploreFailure(response?.data));
    }
  } catch (error: any) {
    yield put(exploreRedux.actions.postFilterInExploreFailure(error));
  }
}

export function* userFilterInExplore(api: any, action: any): SagaIterator {
  const response = yield call(api.userFilterInExplore, action.payload);
  try {
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(exploreRedux.actions.userFilterInExploreSuccess(response?.data));
    } else {
      yield put(exploreRedux.actions.userFilterInExploreFailure(response?.data));
    }
  } catch (error: any) {
    yield put(exploreRedux.actions.userFilterInExploreFailure(error));
  }
}